import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services'
import { registrationPayload, PrivateCoursesPayload, deviceType } from './type'
import apiEndpoints from '../../const/apiEndpoints'
import {
  handleAuthenticate,
  updatePassword,
  updateUserName
} from '../user/actions'
import { resetRegisterState } from './action'

export const saveRegistration = createAsyncThunk(
  'register/save',
  async (data: registrationPayload): Promise<registrationPayload> => {
    const response = await api.post(apiEndpoints.saveRegistration, data)
    return response.data
  }
)

export const completeRegistration = createAsyncThunk(
  'register/complete',
  async (data: registrationPayload, { dispatch }): Promise<any> => {
    const response = await api.post(apiEndpoints.completedRegistration, data)
    const { name, password } = response.data.data
    dispatch(updateUserName(name))
    dispatch(updatePassword(password))
    dispatch(
      handleAuthenticate({
        loginDevice: data.loginDevice as deviceType
      })
    )
    dispatch(resetRegisterState())
    return response.data
  }
)

export const getAllPrivateCourses = createAsyncThunk(
  'register/courses',
  async (): Promise<PrivateCoursesPayload> => {
    const response = await api.get(apiEndpoints.getAllPrivateCourses)
    return response.data.map((course: PrivateCoursesPayload) => ({
      ...course,
      selected: false
    }))
  }
)

export const updatePaymentOrderFailed = createAsyncThunk(
  'register/updatePaymentOrderFailed',
  async (orderId: string): Promise<void> => {
    const response = await api.put(
      `${apiEndpoints.updatePaymentOrderFailed}?orderId=${orderId}`
    )
    return response?.data
  }
)
